import { useMemo } from 'react';
import { useWidgetContext } from '../contexts/widget';
import { useAppDispatch } from '../redux';
import * as widgetActions from '../redux/slices/widget';
export const useWidget = (name, options) => {
    const widgets = useWidgetContext();
    const dispatch = useAppDispatch();
    const widget = widgets.find(widget => widget.name === name);
    const updateWidget = (data) => {
        const isCreate = !widget;
        dispatch(widgetActions.writeData({
            ...widget,
            name,
            data,
            isCreate
        }));
    };
    const defaulWidget = useMemo(() => {
        const defaultWidget = {
            id: 'default',
            name,
            createdAt: new Date().toISOString(),
            modifiedAt: new Date().toISOString(),
            data: options?.defaultData
        };
        return defaultWidget;
    }, [name, options?.defaultData]);
    return [widget || defaulWidget, updateWidget];
};
